import { Link, useLocation } from "react-router-dom"
import { ChevronRightIcon } from "@heroicons/react/24/outline"

export function Breadcrumbs() {
  const location = useLocation()
  const pathnames = location.pathname.split("/").filter((x) => x)

  const breadcrumbNameMap: Record<string, string> = {
    dashboard: "Dashboard",
    users: "Users",
    offers: "Offers",
    diagrams: "Diagrams",
    teams: "Teams",
    "affiliate-statements": "Affiliate statements",
    clips: "Clips",
    search: "Search",
    organizations: "Organizations",
    email: "Email",
    stats: "Stats",
    templates: "Templates",
    log: "Log",
    setup: "Setup",
  }

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        <li>
          <Link to="/dashboard" className="text-secondary hover:text-primary text-sm">
            Home
          </Link>
        </li>
        {pathnames.map((pathname, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`
          const isLast = index === pathnames.length - 1
          const name = breadcrumbNameMap[pathname] || pathname

          return (
            <li key={pathname} className="flex items-center">
              <ChevronRightIcon className="h-4 w-4 text-secondary mx-2" />
              {isLast ? (
                <span className="text-sm font-medium text-primary">{name}</span>
              ) : (
                <Link to={routeTo} className="text-sm text-secondary hover:text-primary">
                  {name}
                </Link>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
